import forge from "node-forge";
import crypto from "crypto";
import AES from "crypto-js/aes";
import { enc } from "crypto-js";

const publicKeyPem = process.env.NEXT_PUBLIC_PUB_KEY!.replace(/\\n/g, "\n");
const publicKey = forge.pki.publicKeyFromPem(publicKeyPem);

export const encryptData = (data: object) => {
  // const encrypted = publicKey.encrypt(JSON.stringify(data));
  // return forge.util.encode64(encrypted);

  const payload = JSON.stringify(data);

  // Step 1: Generate a random AES key
  const aesKey = crypto.randomBytes(32).toString("base64"); // AES-256 key (32 bytes)

  // console.log(aesKey);
  // console.log(enc.Base64.parse(aesKey));

  // Step 2: Encrypt the payload using AES
  const iv = crypto.randomBytes(16).toString("base64"); // Initialization vector

  let encryptedData = AES.encrypt(payload, enc.Base64.parse(aesKey), {
    iv: enc.Base64.parse(iv),
  }).toString();

  const encryptedKey = forge.util.encode64(publicKey.encrypt(aesKey));
  // console.log(aesKey);
  // console.log(encryptedKey);

  return {
    a: encryptedData,
    b: encryptedKey,
    c: iv,
  };
  // const cipher = crypto.createCipheriv('aes-256-cbc', aesKey, iv);
  // let encryptedData = cipher.update(payload, 'utf8', 'base64');
  // encryptedData += cipher.final('base64');

  // Step 3: Encrypt the AES key using RSA
  // const encryptedKey: Buffer = crypto.publicEncrypt(
  //   {
  //     key: publicKey,
  //     padding: crypto.constants.RSA_PKCS1_OAEP_PADDING,
  //   },
  //   aesKey
  // );

  // Result
  // console.log("Encrypted Data:", encryptedData);
  // console.log("Encrypted AES Key:", encryptedKey.toString("base64"));
  // console.log("Initialization Vector:", iv.toString("base64"));

  // return forge.util.encode64(encrypted);
};

// const encrypted = publicKey.encrypt(JSON.stringify(data));
// return forge.util.encode64(encrypted);
